import { array, number, string } from 'prop-types';

const deliveryLocationDistrictBasicInformationPropTypes = {
  locationId: number.isRequired,
  locationName: string.isRequired,
  districtList: array.isRequired,
};

export default deliveryLocationDistrictBasicInformationPropTypes;
